import { DISCLAIMERS, type StaticDisclaimerKey } from '@/lib/compliance/disclaimers';

export interface DisclaimerProps {
  /** 預設 globalFooter——§15.4 要求「每一頁」都有。 */
  variant?: StaticDisclaimerKey;
  className?: string | undefined;
}

/**
 * ARCHITECTURE §15.4 的固定揭露文字。
 *
 * 刻意不接受 children、不接受任意字串：這個元件能渲染的內容，
 * 只有 DISCLAIMERS 裡那幾段（且不含 modelOutput——那是樣板，只能由 <ModelOutput> 展開）。
 * 可以被自由填字的揭露元件等於沒有揭露元件。
 *
 * 注意它**不是** <ModelOutput> 的替代品。§2.6 明確否決了
 * 「靠慣例渲染的共用 <Disclaimer>」這個做法：頁尾揭露解決不了
 * 「某個模型數字旁邊少了它自己的 model_id 與 OOS IC」這件事。
 */
export function Disclaimer({ variant = 'globalFooter', className }: DisclaimerProps) {
  return (
    <p
      data-disclaimer={variant}
      className={['text-11 leading-relaxed text-muted', className ?? ''].join(' ').trim()}
    >
      {DISCLAIMERS[variant]}
    </p>
  );
}
